import { render, staticRenderFns } from "./BLoginPage.vue?vue&type=template&id=933b5972&"
import script from "./BLoginPage.vue?vue&type=script&lang=js&"
export * from "./BLoginPage.vue?vue&type=script&lang=js&"
import style0 from "./BLoginPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCardSection});
